<template>
  <div>
    <mobile-header
      :header-title="headerTitle"
      class="mobile-header"
      @backButton="backButton"
    ></mobile-header>
    <slot
      @setMobileHeader="setMobileHeader"
    ></slot>
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue'

export default {
  components: {
    MobileHeader: defineAsyncComponent(() => import('@/components/header/MobileHeader.vue'))
  },
  data () {
    return {
      headerTitle: '',
      urlBackButton: ''
    }
  },
  async mounted () {
    const hideSociomile = time => new Promise(resolve => setTimeout(() => {
      const sociomile = document.getElementsByClassName('custom_widget')[0]
      if (sociomile) {
        sociomile.style.display = 'none'
        resolve(true)
      } else {
        resolve(false)
      }
    }, time))

    this.$store.commit('SET_ENV_BELAJAR')
    this.$store.commit('SET_ACTIVE_ENVIRONMENT')
    this.$store.dispatch('subnavbar/initMenuList')
    for (let i = 0; i < 5; i++) {
      const sociomile = await hideSociomile(300)
      if (sociomile) {
        break
      }
    }
  },
  methods: {
    backButton () {
      this.$router.push(this.urlBackButton)
    },
    setMobileHeader (obj) {
      this.headerTitle = obj.title
      this.urlBackButton = obj.url
    }
  }
}
</script>

<style scoped>
.mobile-header {
  position: fixed;
  top: 0;
  z-index: 2;
  box-shadow: 0px 2px 8px rgba(51, 51, 51, 0.1);
}
</style>
